import React from 'react'
import { Stack, Title, Text, Button } from '@mantine/core'

interface ErrorBoundaryProps {
  children: React.ReactNode
  fallback?: React.ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
  error?: Error
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error }
  }

  componentDidCatch() {
    // intencional: não logamos o erro (pode conter dados sensíveis)
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback

      return (
        <Stack
          align="center"
          justify="center"
          h="100vh"
          gap="md"
          data-testid="error-boundary"
          role="alert"
        >
          <Title order={3}>Algo deu errado</Title>
          <Text c="dimmed" size="sm">
            Ocorreu um erro inesperado. Recarregue a página para continuar.
          </Text>
          <Button
            variant="light"
            c="brand.9"
            onClick={() => window.location.reload()}
            data-testid="error-boundary-reload"
          >
            Recarregar
          </Button>
        </Stack>
      )
    }

    return this.props.children
  }
}
